export default {"src":"/_next/static/media/icon_play_live_v2.89cd6053.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};